import { EMPTY_LIST } from '../../../../../constants/common'

import {
  LISTING_APPLICANT_ACTION_OPEN,
  LISTING_APPLICANT_ROW_ACTIONS,
  LISTING_APPLICANTS_STATE,
} from './RentalPortalListingProfileApplicants.constants'

export function getListingApplicantsState({
  applicants,
  hasError,
  isInitiated,
}) {
  if (hasError) {
    return LISTING_APPLICANTS_STATE.error
  }

  if (!isInitiated) {
    return LISTING_APPLICANTS_STATE.loading
  }

  return applicants?.length > 0
    ? LISTING_APPLICANTS_STATE.table
    : LISTING_APPLICANTS_STATE.empty
}

export function getListingApplicantItemActions(item) {
  return item?.permissions?.can_view
    ? LISTING_APPLICANT_ROW_ACTIONS
    : EMPTY_LIST
}

export function getIsListingApplicantsEmpty(state) {
  return state === LISTING_APPLICANTS_STATE.empty
}

export function getIsListingApplicantsError(state) {
  return state === LISTING_APPLICANTS_STATE.error
}

export function getIsListingApplicantActionOpen(action) {
  return action === LISTING_APPLICANT_ACTION_OPEN
}
